<template>
  <modal-window v-on:close="close">
    <template slot="header">
      <p class="modal-card-title">{{ header }}</p>
      <button class="delete" v-on:click="$emit('close')" aria-label="close"></button>
    </template>
    <template slot="body">
      {{ text }}
    </template>
    <template slot="footer">
        <button class="button is-danger" v-on:click="$emit('delete')">Delete</button>
        <button class="button" v-on:click="$emit('close')">Cancel</button>
    </template>
  </modal-window>
</template>

<script>
import ModalWindow from "./ModalWindow";
//import this.HTTP from "./Http";

export default {
  name: "delete-confirmer",
  components: { ModalWindow },
  props: {
    header: String,
    text: String
  },
  methods: {
    close() {
      this.$emit("close");
    },
    keyDownListener(evt) {
      if (evt.keyCode === 13) this.$emit('delete');
    }
  },
  created() {
    document.addEventListener("keydown", this.keyDownListener);
  },
  destroyed() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/DeleteConfirmer.Vue